import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import {
  GlobalMessageType,
  GlobalMessageService,
  AuthStorageService,
} from '@spartacus/core'
import { Actions, ofType } from '@ngrx/effects'
import { take } from 'rxjs/operators'
import { CommonService } from '../services/common.service'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
})
export class VSAuthService {
  private authErrorSource = new BehaviorSubject<any>({})
  authErrorError$ = this.authErrorSource.asObservable()

  constructor(
    // private userTokenEffects: UserTokenEffects,
    private globalMessageService: GlobalMessageService,
    private router: Router,
    private authStorageService: AuthStorageService
  ) {}

  setDeliveryGroupErrors(errorsObj: any) {
    this.authErrorSource.next(errorsObj)
  }

  clearAuthSession() {
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe(
        (data) => {
          if (data && data.access_token) {
            if (data.access_token) {
              localStorage.clear()
              this.router.navigate(['login'])
            }
          }
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
}
